
import React from "react"

export const LogoMark: React.FC<{
  className?: string
  size?: number | string // Back-compat: treated as height
  height?: number | string // Preferred
}> = ({
  className,
  size = 48, // default height
  height: heightProp,
}) => {
  // Height-first sizing so it pairs cleanly with WordMark
  const h = heightProp ?? size
  let width: string | undefined = undefined
  let height: string | undefined = undefined

  if (typeof h === "number") {
    height = `${h}px`
    width = `${Math.round(h * (136 / 111))}px` // width from aspect
  } else if (typeof h === "string" && /^\d+(\.\d+)?(px|em|rem|%)?$/.test(h)) {
    height = h
    width = undefined // aspect-ratio determines width
  }

  return (
    <span
      className={className}
      style={{
        display: "inline-block",
        width,
        height,
        aspectRatio: "136 / 111",
      }}
    >
      <svg
        viewBox="0 0 136 111"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          width: "100%",
          height: "100%",
          display: "block",
        }}
        aria-hidden="true"
        focusable="false"
      >
        <path d="M0 110.155H101.31L135.596 0H34.3249L0 110.155Z" fill="currentColor" />
      </svg>
    </span>
  )
}

